import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: Keycloak_URL,
  realm: Keycloak_Realm,
  clientId: Keycloak_ClientId,
});

export default keycloak;

export async function getUserPermissions(keycloakInstance: any): Promise<any[]> {
  let permissions: any[] = [];
  try {
    const authUrl = keycloakInstance.authServerUrl?.replace(/\/$/, '');
    const realm = keycloakInstance.realm;

    if (authUrl && realm) {
      const resp = await fetch(`${authUrl}/realms/${realm}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${keycloakInstance.token}`,
        },
        body: new URLSearchParams({
          audience: 'vnhw-budget-api',
          response_mode: 'permissions',
          grant_type: 'urn:ietf:params:oauth:grant-type:uma-ticket',
        }),
      });

      if (resp.ok) {
        permissions = await resp.json();
      }
    }
  } catch (e) {
    permissions = [];
  }
  return permissions;
}
